import { render, staticRenderFns } from "./VuetifyMultipleAutocomplete2.vue?vue&type=template&id=67051e0e"
import script from "./VuetifyMultipleAutocomplete2.vue?vue&type=script&lang=js"
export * from "./VuetifyMultipleAutocomplete2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports